import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'seamless-immutable';
import { Checkbox } from '../../components';
import ErrorIcon from '@material-ui/icons/Close';
import theme from '../../app.theme';

class Answer extends Component {
  constructor(props) {
    super(props);

    this.state = {

    };
  }

  getStateClass() {
    if (!this.props.completed) {
      return null;
    }

    const answer = this.props.answer;
    if (answer.isValidAnswer) {
      if (answer.answeredCorrectly) {
        if (this.props.completed) {
          return styles.correct;
        }
        return styles.wrong;
      }
      return styles.correct;
    } else if (!answer.answeredCorrectly) {
      return styles.wrong;
    }
  }

  renderCheckbox() {
    if (this.props.completed) {
      const style = this.getStateClass();
      const checkedIcon = (this.props.answer.isValidAnswer) ? null : <ErrorIcon />;
      const unCheckedIcon = (!this.props.answer.isValidAnswer && !this.props.answer.answeredCorrectly) ? <ErrorIcon /> : null;

      return (<Checkbox
        iconStyle={{ ...(this.props.small ? styles.iconStyleSmall : styles.iconStyle), fill: style && style.borderColor }}
        checked={this.props.answer.isValidAnswer && this.props.answer.answeredCorrectly}
        checkedIcon={checkedIcon}
        style={{ display: 'block' }}
        uncheckedIcon={unCheckedIcon}
        labelStyle={{ lineHeight: this.props.small ? '28px' : '40px' }}
        label={this.props.answer.text}
      />);
    }

    return <Checkbox style={{ display: 'block' }} iconStyle={styles.iconStyle} labelStyle={{ lineHeight: '40px' }} label={this.props.answer.text} onCheck={this.props.onCheck} checked={this.props.isSelected} />;
  }

  render() {
    if (!this.props.answer) {
      return null;
    }

    const checked = (this.props.completed && this.props.answer.isValidAnswer);
    return (
      <div style={styles.answer} key={this.props.answer.id}>
        {this.renderCheckbox()}
      </div>
    );
  }
}

const styles = {
  answer: {
    marginBottom: 20,
  },
  selected: {
    borderColor: '#999',
  },
  wrong: {
    borderColor: '#d04f30',
  },
  correct: {
    borderColor: '#00921f',
  },
  iconStyle: {
    width: 40,
    height: 40,
    marginLeft: -5,
    borderColor: '#999',
    fill: '#999',
  },
  iconStyleSmall: {
    width: 25,
    height: 25,
  },
};

export default Answer;



// WEBPACK FOOTER //
// ./src/app/main/test/answer.js